import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IInvoice } from "../models/invoice/IInvoice";
import { DefaultResponseWithData } from "../models/system";

export default function usePartInvoice(partId: string | undefined) {
  const { get } = useApiHelper();
  const staleTime = 1000 * 60; // 1 minute
  const enabled = Boolean(partId);

  const invoice = useQuery({
    queryKey: ["parts", partId, "invoice"],
    queryFn: () =>
      get<DefaultResponseWithData<IInvoice>>(`/part/${partId}/invoice`),
    staleTime,
    refetchOnWindowFocus: false,
    enabled,
  });

  return { invoice };
}
